module.exports = __webpack_public_path__ + "static/media/hero-image-placeholder.ad0fb483.png";